export default "__VITE_ASSET__CdmGhY9B__"